import { render, staticRenderFns } from "./NewPasswordUser.vue?vue&type=template&id=4346361a&scoped=true&"
import script from "./NewPasswordUser.vue?vue&type=script&lang=js&"
export * from "./NewPasswordUser.vue?vue&type=script&lang=js&"
import style0 from "./NewPasswordUser.vue?vue&type=style&index=0&id=4346361a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4346361a",
  null
  
)

export default component.exports